import axios from "axios";

import Config from "../../config";

const getActionListaSetoresByClienteId = clienteId => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/setores/lista/byClienteId/${clienteId}`
    });
};

export default getActionListaSetoresByClienteId;
